import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app";
import "./i18n";
import "./assets/fonts/font.ttf";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  // no StrictMode - react-modal isn't StrictMode-safe (double mount in dev
  // throws "Cannot register modal instance that's already open"), and it's
  // a no-op in prod builds anyway
  root.render(<App />);
}
